var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-container"},[_c('v-treeview',{attrs:{"items":_vm.eventErrorList,"item-children":"events","activatable":"","color":"red"},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var item = ref.item;
return [_c('a',{on:{"click":function($event){return _vm.showContext(item.context, item.createdDate)}}},[_vm._v(_vm._s(item.type))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }